export const SET_BANK_ACCOUNTS = 'setBankAccounts'
export const SET_BANK_ACCOUNT = 'setBankAccount'
export const SET_BANK_ACCOUNTS_DEFAULT = 'setBankAccountsDefault'
export const REMOVE_BANK_ACCOUNT = 'removeBankAccount'
export const REMOVE_MOVEMENT_ACCOUNT = 'removeMovementAccount'
export const FINANCIAL_RESET_STATE = 'financialReset' 
export const FINANCIAL_ID_RESET_STATE = 'financialIDResetState'
export const SET_FINANCE_PAGINATION = 'setFinancePagination'
export const SET_PAYMENT_PAGINATION = 'setPaymentPagination'
export const SET_LIST_ACCOUNTS = 'setListAccounts'
export const SET_FINANCE = 'setFinance'
export const SET_FINANCES = 'setFinances'
export const SET_FINANCIAL = 'setFinancial'
export const SET_PAYMENTS = 'setPayments'
export const SET_MOVEMENTS_ACCOUNTS = 'setMovementsAccounts'
export const SET_RECEIPT_ACCOUNTS = 'setReceiptAccounts'